import { render, staticRenderFns } from "./arrow-chart.vue?vue&type=template&id=1e45bf58&scoped=true&"
import script from "./arrow-chart.vue?vue&type=script&lang=js&"
export * from "./arrow-chart.vue?vue&type=script&lang=js&"
import style0 from "./arrow-chart.vue?vue&type=style&index=0&id=1e45bf58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45bf58",
  null
  
)

export default component.exports